/* unplugin-vue-components disabled */
import ChatInput from 'components/chat-input'
import ChatInputV2 from 'components/chat-input-v2'
import {HINTS} from './hints-defs'
import Hint from './hint.vue'
import $chats from 'stores/chats'
import $profile from 'stores/profile'
import {computed} from 'vue'

export default {
  components: {
    ChatInput,
    Hint,
    ChatInputV2
  },
  provide() {
    return {
      di_chat_mode: computed({
        get: () => this.mode,
        set: mode => this.mode = mode
      })
    }
  },
  data(){
    return {
      empty: true,
      loading: true,
      input_text: '',
      mode: 'deep',
    }
  },
  computed: {
    chat_2(){
      return $profile.chat_type === 'chat_v2'
    },
    hints(){
      const x = $utils.randomInt(0, 2)
      let y
      do y = $utils.randomInt(0, 2)
      while (x === y)

      return [
        {
          pre: HINTS[x].pre,
          post: HINTS[x].posts[$utils.randomInt(0, HINTS[x].posts.length - 1)]
        },
        {
          pre: HINTS[y].pre,
          post: HINTS[y].posts[$utils.randomInt(0, HINTS[y].posts.length - 1)]
        }
      ]

    },
  },
  methods: {
    async onChat(query) {
      const user_query = {...query, mode: this.mode}
      const chat = await $chats.newChat(user_query, $profile.chat_type)
      this.$global.goToChat(chat.id)
    },
    setText(text){
      this.input_text = `${text} `
      this.$refs.chat.focus()
    }
  }
}
